import React from 'react';

import './AdjustmentsDisclosure.scss';
import DisclosureModal from 'components/shared/Disclosure/DisclosureModal';
import Content from 'services/Content';

const AdjustmentsDisclosure = () => {
    return <div className="activity-adjustments-disclosure">
              <DisclosureModal
                className="restricted-height-modal"
                content={Content.activitySummaryAdjustmentsDisclosure}
                hideLinkContent/>
            </div>
};

export default AdjustmentsDisclosure;
